import {
  faCalendarAlt,
  faClock,
  faIdBadge,
  faBuilding
} from '@fortawesome/free-regular-svg-icons';
import {
  faLayerGroup,
  faList,
  faShieldAlt
} from '@fortawesome/free-solid-svg-icons';
import Department from 'pages/settings/Department/Department';
import Designation from 'pages/settings/Designation/Designation';
import Holiday from 'pages/settings/Holiday/Holiday';
import Material from 'pages/settings/Material/Material';
import PermissionsManager from 'pages/settings/role-permission/PermissionManage';
// import RolePermissions from 'pages/settings/role-permission/RolePermissions';
import Shift from 'pages/settings/Shift/Shift';
import VehicleType from 'pages/settings/VehicleType/VehicleType';

const settingSiteMap = [
  //   {
  //     name: 'Back to Home',
  //     path: '/',
  //     icon: 'home',
  //     eventKey: 'home',
  //     className: 'text-danger'
  //   },
  {
    name: 'Department',
    moduleName: 'Department',
    actionName: 'view',
    active: true,
    path: '/settings/department',
    iconSet: 'font-awesome',
    icon: faBuilding,
    eventKey: 'department',
    content: <Department />
  },
  {
    name: 'Designation',
    moduleName: 'Designation',
    actionName: 'view',
    active: true,
    path: '/settings/designation',
    iconSet: 'font-awesome',
    icon: faIdBadge,
    eventKey: 'designation',
    content: <Designation />
  },
  {
    name: 'Shifts',
    moduleName: 'Shifts',
    actionName: 'view',
    active: true,
    path: '/settings/shift',
    iconSet: 'font-awesome',
    icon: faClock,
    eventKey: 'shift',
    content: <Shift />
  },
  {
    name: 'Holidays',
    moduleName: 'Holidays',
    actionName: 'view',
    active: true,
    path: '/settings/holidays',
    iconSet: 'font-awesome',
    icon: faCalendarAlt,
    eventKey: 'holidays',
    content: <Holiday />
  },
  {
    name: 'Material',
    moduleName: 'Material',
    actionName: 'view',
    active: true,
    path: '/settings/material',
    iconSet: 'font-awesome',
    icon: faLayerGroup,
    eventKey: 'material',
    content: <Material />
  },
  {
    name: 'Vehicle Type',
    moduleName: 'Vehicle Type',
    actionName: 'view',
    active: true,
    path: '/settings/vehicleType',
    iconSet: 'font-awesome',
    icon: faList,
    eventKey: 'vehicleType',
    content: <VehicleType />
  },
  {
    name: 'Roles & Permissions',
    moduleName: 'Role Permission',
    actionName: 'view',
    active: true,
    path: '/settings/roles-permission',
    iconSet: 'font-awesome',
    icon: faShieldAlt,
    eventKey: 'roles-permission',
    content: <PermissionsManager />
  }
  // {
  //   name: 'Roles & Permissions',
  //   moduleName: 'rolls_permissions',
  //   active: true,
  //   path: '/settings/rolePermissions',
  //   iconSet: 'font-awesome',
  //   icon: faIdBadge,
  //   eventKey: 'rolePermissions',
  //   content: <RolesAndPermissions />
  // }
  // {
  //   name: 'Leave',
  //   active: true,
  //   path: '/settings/leave',
  //   iconSet: 'font-awesome',
  //   icon: faCalendarAlt,
  //   eventKey: 'leave',
  //   content: <Leave />
  // },
  // {
  //   name: 'Advanced',
  //   active: true,
  //   path: '/settings/advanced',
  //   icon: 'box',
  //   eventKey: 'advanced',
  //   pages: [
  //     {
  //       active: true,
  //       name: 'Advanced Second',
  //       path: '/settings/advanced-second',
  //       eventKey: 'advanced-second'
  //     },
  //     {
  //       active: true,
  //       name: 'Advanced third',
  //       path: '/settings/advanced-third',
  //       eventKey: 'advanced-third'
  //     },
  //     {
  //       active: true,
  //       name: 'Advanced     fourth',
  //       path: '/settings/advanced-fourth',
  //       eventKey: 'advanced-fourth'
  //     }
  //   ]
  // }
];

export default settingSiteMap;
